import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var suggestionsCache = {};
var emptyResult = {
  suggestions: []
};
export var mountApiUrl = function mountApiUrl(url, fquery, currentCategoryId, testId, categoryIdFilter) {
  var currentCategoryIdString = currentCategoryId ? "&current_category_id=" + currentCategoryId : '';
  var testIdQueryString = testId ? "&test_id=" + testId : '';
  var categoryFilterQueryString = categoryIdFilter ? "&filter_category=1&category=" + categoryIdFilter : '';
  return url + "?query=" + fquery + currentCategoryIdString + testIdQueryString + categoryFilterQueryString;
};
export var hasCategory = function hasCategory(obj) {
  return obj && Object.prototype.hasOwnProperty.call(obj, 'category');
};
export var getCategorySuggestions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, query, currentCategoryId, testId, categoryIdFilter, suggestIntention) {
    var fquery, currentCategoryIdCacheKey, categoryIdFilterCacheKey, cacheKey, inputValue, inputLength, apiUrl, request, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fquery = encodeURIComponent(query);
            currentCategoryIdCacheKey = currentCategoryId ? "_" + currentCategoryId : '';
            categoryIdFilterCacheKey = categoryIdFilter ? categoryIdFilter + "_" : '';
            cacheKey = "" + categoryIdFilterCacheKey + query.toLowerCase() + currentCategoryIdCacheKey;
            inputValue = fquery.toLowerCase();
            inputLength = inputValue.length;
            apiUrl = mountApiUrl(url, fquery, currentCategoryId, testId, categoryIdFilter, suggestIntention);

            if (!(inputLength === 0 || inputValue.match(/['‘’"“”]/g))) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", Promise.resolve(emptyResult));

          case 11:
            if (!(cacheKey in suggestionsCache)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", Promise.resolve(suggestionsCache[cacheKey]));

          case 15:
            _context.prev = 15;
            _context.next = 18;
            return fetch(apiUrl);

          case 18:
            request = _context.sent;
            _context.next = 21;
            return request.json();

          case 21:
            response = _context.sent;
            suggestionsCache[cacheKey] = response;
            return _context.abrupt("return", response);

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](15);
            return _context.abrupt("return", emptyResult);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[15, 26]]);
  }));

  return function getCategorySuggestions(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();